/* eslint-disable prettier/prettier */
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { StatusCodes } from "http-status-codes";
import { AssignedPaginatedMembers } from "../../../@types/api/admin/user/user.types";
import { PaginationQuery } from "../../../@types/pagination.types";
import { GroupOwnerTypes } from "../../../@types/components/groupOwner.types";
const { post, get, put, del, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "user";

// eslint-disable-next-line prettier/prettier, arrow-parens
export const getEachUser = async () => {
	try {
		const endpoint = `${initialRoute}/get-each-user`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Unauthorised Role!") {
				alert("Unauthorised Role!");
			} else if (message === MESSAGE.get.empty) {
				alert("Database Empty");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to get members!");
			} else alert("Other Errors of Status Code 400");
		} else {
			throw error;
		}
	}
};

export const getGroupOwnerByAuth = async () => {
	try {
		const endpoint = `${initialRoute}/group-owner`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			// alert(message);
			throw error;
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			// alert(message);
			throw error;
		} else {
			throw error;
		}
	}
};

export const getGroupOwnerCount = async (): Promise<number> => {
	try {
		const endpoint = `${initialRoute}/group-owners/count`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getGroupOwnerById = async (id: string) => {
	try {
		const endpoint = `${initialRoute}/group-owner/${id}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getEmployers = async (filter: Record<string, unknown>) => {
	try {
		const endpoint = `${initialRoute}/group-owners`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filter
		);

		if (response) {
			const {
				data: { message, result, pagination }
			} = response;

			if (message === MESSAGE.get.succ) {
				return { result, pagination };
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getAssignedPaginatedMembers = async (query: PaginationQuery): Promise<AssignedPaginatedMembers> => {
	try {
		const endpoint = `${initialRoute}/members/assinged/paginated`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

// For particular group, members are fetched.
export const getPaginatedMembersByGroupAndAssignedLocation = async (
	query: PaginationQuery,
	group_number: number
): Promise<AssignedPaginatedMembers> => {
	try {
		const endpoint = `${initialRoute}/members/groups/assigned-location/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getMemberCount = async (): Promise<number> => {
	try {
		const endpoint = `${initialRoute}/members/count`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getMemberCountOfParticularGroup = async (group_number: number): Promise<number> => {
	try {
		const endpoint = `${initialRoute}/group/member/count/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getAssignedGroupOwners = async (query: Record<string, unknown>) => {
	try {
		const endpoint = `${initialRoute}/group-owners/assigned`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);

		if (response) {
			const {
				data: { message, result, pagination }
			} = response;

			if (message === MESSAGE.get.succ) {
				return { result, pagination };
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getEnrollers = async (filter: Record<string, unknown>) => {
	try {
		const endpoint = `${initialRoute}/get-enrollers`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filter
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const updateUserPermissionManagement = async (_payload: any, params: string) => {
	try {
		const payload = JSON.stringify(_payload);

		const endpoint = `update-user-permissions/${params}`;
		const token = localStorage.getItem("@jwt");

		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;

			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}

		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const groupOwner = {
	getGroupOwnerByAuth,
	getGroupOwnerCount,
	getGroupOwnerById,
	getAssignedPaginatedMembers,
	getMemberCount,
	getMemberCountOfParticularGroup,
	getAssignedGroupOwners,
	getEmployers,
	getPaginatedMembersByGroupAndAssignedLocation,
	getEnrollers,
	updateUserPermissionManagement
};
